import Config from "../service/Config";

export default (uri) => {
    return 'dist/' + Config.version + '/asset/' + uri;
}
